import React from "react";
import { Icon, Text } from "@zorni/components-lib";
import { useTranslation } from "react-i18next";
import styles from "../PublishTrip.module.css";
import { formatDisplayDate, numberValue } from "../utils/publishTrip.helpers";

const TripDateCard = ({ tripDate, index, coverageLabel, onEdit, onDelete, canDelete }) => {
  const { t } = useTranslation();
  const seats = tripDate?.seatsAvailable || tripDate?.SeatsAvailable || {};
  const travelManagers = tripDate?.travelManagers || [];
  const managersCount = travelManagers.length;
  const singleManager = managersCount === 1 ? travelManagers[0] : null;
  const totalSeats =
    Number(seats?.numberOfSeatsAvailable || 0) +
    Number(seats?.numberOfChildrensSeatsAvailable || 0) +
    Number(seats?.numberOfBabiessSeatsAvailable || 0);

  return (
    <div className={styles.tripDateCard}>
      <div className={styles.dateHeader}>
        <div>
          <Text as="p" weight="bold">
            {t("tripPublication.publishTrip.instanceNumber", { number: index + 1 })}
          </Text>
          <Text as="p">
            {formatDisplayDate(tripDate.startDate)} - {formatDisplayDate(tripDate.endDate)}
          </Text>
        </div>

        <div className={styles.dateActions}>
          {tripDate.isCheapestDate && (
            <Text as="span" className={styles.bestPriceBadge} weight="bold">
              {t("tripPublication.publishTrip.labels.bestPrice")}
            </Text>
          )}
          <Icon
            name="iconPenToSquare"
            size="sm"
            onClick={onEdit}
            title={t("tripPublication.publishTrip.actions.editInstance")}
          />
          {canDelete && (
            <Icon
              name="iconTrash"
              size="sm"
              onClick={onDelete}
              title={t("tripPublication.publishTrip.actions.deleteInstance")}
            />
          )}
        </div>
      </div>

      <div className={styles.statsGrid}>
        <div className={styles.statCard}>
          <div className={styles.statTitleRow}>
            <Icon name="iconPriceQuality" size="xs" />
            <Text as="span">{t("tripPublication.publishTrip.labels.price")}</Text>
          </div>
          <Text as="p" weight="bold">
            {t("tripPublication.publishTrip.labels.adultPriceValue", {
              value: numberValue(tripDate.adultPricePerPerson),
            })}
          </Text>
          <Text as="small">
            {t("tripPublication.publishTrip.labels.childPriceValue", {
              value: numberValue(tripDate.childPricePerPerson),
            })}{" "}
            |{" "}
            {t("tripPublication.publishTrip.labels.babyPriceValue", {
              value: numberValue(tripDate.babiesPricePerPerson),
            })}
          </Text>
        </div>

        <div className={styles.statCard}>
          <div className={styles.statTitleRow}>
            <Icon name="iconCalendar" size="xs" />
            <Text as="span">{t("tripPublication.publishTrip.labels.duration")}</Text>
          </div>
          <Text as="p" weight="bold">
            {t("tripPublication.publishTrip.labels.durationValue", {
              days: tripDate.nbDays,
              nights: tripDate.nbNight,
            })}
          </Text>
          <Text as="small">
            {t("tripPublication.publishTrip.labels.availableSeats", { count: totalSeats })}
          </Text>
        </div>

        <div className={styles.statCard}>
          <div className={styles.statTitleRow}>
            <Icon name="iconPath" size="xs" />
            <Text as="span">{t("tripPublication.publishTrip.labels.assignedSteps")}</Text>
          </div>
          <Text as="p" weight="bold">
            {t("tripPublication.publishTrip.labels.stepDatesCount", {
              count: tripDate.stepsDate?.length || 0,
            })}
          </Text>
          <Text as="small">{coverageLabel}</Text>
        </div>

        <div className={styles.statCard}>
          <div className={styles.statTitleRow}>
            <Icon name="iconIdCard" size="xs" />
            <Text as="span">{t("tripPublication.publishTrip.labels.travelManagers")}</Text>
          </div>

          {singleManager ? (
            <>
              <Text as="p" weight="bold" className={styles.managerInfoLine}>
                {singleManager?.fullName || "-"}
              </Text>
              <Text as="small" className={styles.managerInfoLine}>
                {singleManager?.email || "-"}
              </Text>
              <Text as="small" className={styles.managerInfoLine}>
                {singleManager?.phoneNumber?.number || "-"}
              </Text>
            </>
          ) : managersCount > 1 ? (
            <Text as="p" weight="bold">
              {t("tripPublication.publishTrip.labels.managersCount", {
                count: managersCount,
              })}
            </Text>
          ) : (
            <Text as="small">{t("tripPublication.publishTrip.labels.noManager")}</Text>
          )}
        </div>
      </div>
    </div>
  );
};

export default TripDateCard;
